import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import { ChevronLeftIcon } from "@dotnet/telematics-design-system";

import Button from "components/DesignComponents/Button";
import {
    BUTTON_COLORS,
    BUTTON_SIZES,
    BUTTON_VARIANTS
} from "components/DesignComponents/Button/types/enums";
import {
    TOOLTIP_PLACEMENT,
    TooltipGeneral
} from "components/DesignComponents/Tooltips";
import { svgFontSize } from "shared/styles/styleFunctions";

const LeftArrowButton = ({ ...props }) => {
    const { t } = useTranslation();

    return (
        <TooltipGeneral
            placement={TOOLTIP_PLACEMENT.Top}
            title={t("Button##previous month")}
            disableTouchListener
        >
            <span>
                <Button
                    {...props}
                    color={BUTTON_COLORS.White}
                    size={BUTTON_SIZES.Tiny}
                    variant={BUTTON_VARIANTS.IconOnly}
                    icon={<ChevronLeftIcon css={css({ ...svgFontSize(16) })} />}
                    css={css({
                        marginRight: "-20px"
                    })}
                />
            </span>
        </TooltipGeneral>
    );
};

export default LeftArrowButton;
